/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsSerialNumberHistory,
    ControlcenterMelcoModelsSerialNumberHistoryFromJSON,
    ControlcenterMelcoModelsSerialNumberHistoryFromJSONTyped,
    ControlcenterMelcoModelsSerialNumberHistoryToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsSerialNumberHistory>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory
     */
    list: Array<ControlcenterMelcoModelsSerialNumberHistory>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory {
    return ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsSerialNumberHistoryFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistoryToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsSerialNumberHistory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsSerialNumberHistoryToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


